function registry() {
    window.dafCardTypeHandlers = window.dafCardTypeHandlers || {};
    return window.dafCardTypeHandlers;
}

export function registerDafCardTypeHandler(prefix, handler) {
    registry()[prefix] = handler;
}

export function getDafCardTypeHandler(prefix) {
    return registry()[prefix];
}
